var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBarChart10 = function SvgBarChart10(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000713",
    fillRule: "evenodd",
    d: "M6.957 1.36c-.412.062-.8.34-.976.702-.123.252-.147.447-.147 1.223l-.001.712-1.46.008c-1.445.009-1.462.01-1.63.07-.464.167-.77.512-.87.979-.059.28-.059 8.28 0 8.559.058.272.159.456.358.656.2.199.384.3.656.357.28.06 10.945.06 11.225 0a1.2 1.2 0 0 0 .655-.359c.199-.2.303-.388.36-.654.058-.278.058-5.614 0-5.892a1.3 1.3 0 0 0-.87-.979c-.169-.06-.186-.061-1.63-.07l-1.46-.009-.001-2.044c0-2.218-.003-2.262-.148-2.557a1.37 1.37 0 0 0-.762-.653c-.17-.062-.178-.062-1.663-.066-.821-.002-1.557.005-1.636.017M9.833 8v5.333H7.166V2.667h2.667zm-4 1.333v4H3.166v-8h2.667zm8 1.334v2.666h-2.667V8h2.667z",
    clipRule: "evenodd"
  })));
};
export default SvgBarChart10;